import { createAction, props } from '@ngrx/store';

// Action to start loading (when API call begins)
export const incrementLoading = createAction('[Loading] Increment',
    props<{ context: string }>()
);

// Action to stop loading (when API call finishes)
export const decrementLoading = createAction('[Loading] Decrement',
    props<{ context: string }>()
);